
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categoryVideos",
      function () {
        return require("private-next-pages/categoryVideos.js");
      }
    ]);
  